import http from '../_http'

const mail = {
  //default
  summaryMail: (m) => { return http.get(`manager/setting/mail`, m); },
  listMail: (m) => { return http.post(`manager/setting/mail/list`, m); },
  detailMail: (m) => { return http.get(`manager/setting/mail/${m.id}`); },

  //crud
  insertMail: (m) => { return http.post(`manager/setting/mail`, m); },
  updateMail: (m) => { return http.put(`manager/setting/mail`, m); },
  deleteMail: (m) => { return http.delete(`manager/setting/mail/${m.id}`); },
}

export default mail

export { mail }